<template>
  <v-app id="inspire" class="theme-transition">
    <v-main class="base">
      <DocumentHeader />
      <v-fade-transition mode="out-in" appear>
        <v-container>
          <v-row>
            <DocumentGuide v-if="!showSide" :path="path" />
            <v-col>
              <v-sheet
                min-height="90vh"
                rounded="lg"
                class="main-container pa-3"
                @scroll="handleScroll"
                ref="content"
                elevation="3"
              >
                <v-fade-transition mode="out-in" appear>
                  <router-view />
                </v-fade-transition>
              </v-sheet>
            </v-col>
            <v-fab-transition mode="out-in">
              <v-btn
                elevation="10"
                fab
                class="btn-to-top"
                v-if="showBackToTop"
                @click="backToTop()"
              >
                <v-icon>
                  {{ $config.icons.up }}
                </v-icon>
              </v-btn>
            </v-fab-transition>
          </v-row>
        </v-container>
      </v-fade-transition>
    </v-main>
  </v-app>
</template>

<script>
import breakpoints from "@/mixins/breakpoints.mixins.js";
export default {
  components: {
    DocumentHeader: () => import("@/docs/components/DocumentHeader.vue"),
    DocumentGuide: () => import("@/docs/components/DocumentGuide.vue"),
    // DocumentTopics: () => import("@/docs/components/Document.Topics.vue"),
  },
  mixins: [breakpoints],
  metaInfo: {
    title: "Central de Ajuda | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Central de Ajuda | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      path: "",
      showBackToTop: false,
      scrollThreshold: 500,
      showSide: false,
    };
  },
  methods: {
    backToTop() {
      this.$refs.content.$el.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleScroll() {
      this.showBackToTop =
        this.$refs.content.$el.scrollTop > this.scrollThreshold;
    },
  },
  beforeMount() {
    if (!this.$axios.getLocal("oe_user_info")) {
      this.$axios.rota("/");
    }
    if (
      this.$route.path == "/docs/home" ||
      this.$route.path == "/docs/updates" ||
      this.$route.path == "/docs/search"
    ) {
      this.showSide = true;
    }
  },
  watch: {
    $route(e) {
      this.path = e.name;
      if (
        e.path == "/docs/home" ||
        e.path == "/docs/updates" ||
        e.path == "/docs/search"
      ) {
        this.showSide = true;
      } else {
        this.showSide = false;
      }
    },
  },
  mounted() {
    this.path = this.$route.name;
    //   if (
    //     this.$route.path == "/docs/home" ||
    //     this.$route.path == "/docs/updates" ||
    //     this.$routepath == "/docs/search"
    //   ) {
    //     this.showSide = true;
    //   } else {
    //     this.showSide = false;
    //   }
  },
  beforeRouteUpdate(to, from, next) {
    this.$refs.content.$el.scrollTo({ top: 0, behavior: "auto" });
    next();
  },
};
</script>

<style scoped>
#inspire {
  scroll-behavior: smooth;
}
#inspire ::-webkit-scrollbar {
  width: 0.4375rem;
  margin-right: 0.125rem;
}
#inspire ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0.3125rem grey;
  border-radius: 0.9375rem;
}
#inspire ::-webkit-scrollbar-thumb {
  background: #c9c9c9;
  border-radius: 0.625rem;
}
#inspire ::-webkit-scrollbar-thumb {
  background: #616361;
  border-radius: 0.625rem;
}
#inspire ::-webkit-scrollbar-thumb:hover {
  background: #393939;
}
.main-container {
  overflow: auto;
  height: 80vh;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
}
.btn-to-top {
  position: fixed;
  right: 15px;
  bottom: 26px;
}
.theme-transition {
  transition: background-color 0.5s, color 0.5s ease-in-out;
}
.theme--light .theme-transition {
  background-color: white;
  color: black;
}
.theme--dark .theme-transition {
  background-color: #424242;
  color: white;
}
</style>
